<template>
    <div class="">
    <!-- <div class="user-profile-collection"></div> -->
    
      <template v-if="users.length > 0">
        
        <div v-for="(user, index) in users"  :key="user.id"   class="user-profile-collection">
          <div 
            class="user-photo mr-1"
            :style="{ 
              backgroundImage: `url(${(user.photo) ? user.photo : person})`,
              left: `${index * 20}px`            
            }"
            :title="user.name"        
            :id="'olivertooltip-' + index"
            data-toggle="tooltip"
            @click="goToUser(user.id)"
            >            
          </div>
          <div>
            <span class="text-primary" @click="goToUser(user.id)">{{ user.name }}</span>
            - {{ user.status }} - {{ user.cold_meeting_rate }} - {{ user.hours_worked }}
            <span v-if="getClientPriority(user) !== null" :class="getClientPriorityClass(getClientPriority(user))"> - Client priority {{ getClientPriority(user) }}</span>
          </div>
        </div>       
        
      </template>
    </div>
  </template>
  
  <script>
  
  import $ from "jquery";
  import { usersService } from "@/_services";

  export default {
    props: {
      client_id: {
        type: String,
        default: null,
      },
      target_id: {
        type: String,
        default: null,
      },
      client_priority: {
        type: [String, Number],
        default: "",
      },
    },

    created() {
      this.getUsersBooker(this.client_id, this.target_id);
    },

    data() {
      return {
        users: [],
        person: 'data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjMyIiB3aWR0aD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHJ4PSIxNiIgZmlsbD0iIzkwY2FmOSIvPjxjaXJjbGUgY3g9IjE2IiBjeT0iMTIiIHI9IjUiIGZpbGw9IndoaXRlIi8+PHBhdGggZD0iTTE2IDE4Yy02LjYgMC0xMiA0LjItMTIgOXYxYzAgMS4xLjkgMiAyIDJoMjhjMS4xIDAgMi0uOSAyLTJ2LTFjMC00LjgtNS40LTktMTItOXoiIGZpbGw9IndoaXRlIi8+PC9zdmc+'
      };
    },

    methods: {
      getClientPriority(user) {
        const value = user && user.priority !== undefined && user.priority !== null && user.priority !== "" ? user.priority : this.client_priority;
        if (value === undefined || value === null || value === "") {
          return null;
        }
        const normalized = Number(value);
        return Number.isNaN(normalized) ? null : normalized;
      },
      getClientPriorityClass(priority) {
        if (priority === 1) return "text-danger";
        if (priority === 2) return "text-warning";
        if (priority === 3) return "text-secondary";
        return "text-secondary";
      },
      goToUser(user_id) {
        window.open("/users/" + user_id, "_blank");
      },
      getUsersBooker(client_id, target_id) {

        if(this.client_id != '' && this.client_id != null) {

          usersService.getUserBookerByClient(client_id)
          .then((res) => {
            if (res !== undefined) {
              this.users = res.result;
              this.users.forEach(user => {
                if(user.has_avatar == 1){
                  let base64 = '';
                  base64 = btoa(`usr-${user.id}`);
                  user.photo = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
                }else{
                  user.photo = this.person;
                }
              })
              this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip(); // activa todos los tooltips
              });

            }
          })
          .catch((err) => {
            console.log(err);
          });
        } else {
          usersService.getUserBookerByTarget(this.target_id)
          .then((res) => {
            if (res !== undefined) {
              this.users = res.result;
              this.users.forEach(user => {
                if(user.has_avatar == 1){
                  let base64 = '';
                  base64 = btoa(`usr-${user.id}`);
                  user.photo = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
                }else{
                  user.photo = this.person;
                }
              })
            }
          })
          .catch((err) => {
            console.log(err);
          });
         
        }        
      },
    },

  };

  
  </script>
  
  <style scoped>
  .user-profile-collection {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }
  
  .user-photo {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    border: 2px solid #fff; 
    transition: transform 0.2s ease-in-out;
  }
  
  .user-photo:hover {
    transform: scale(1.1); 
  }
  </style>
  